module.exports = __webpack_public_path__ + "img/四川大学华西口腔医院.66106441.png";